const customReportEndpoints = {
  list: (companyId: string) => `/companies/${companyId}/reporting/custom/reports` as const,
  detail: (companyId: string, reportId: number) =>
    `/companies/${companyId}/reporting/custom/reports/${reportId}` as const,
  listGroup: (companyId: string) => `/companies/${companyId}/reporting/custom/reports/groups` as const,
  detailGroup: (companyId: string, id: number) =>
    `/companies/${companyId}/reporting/custom/reports/groups/${id}` as const,
  structure: (companyId: string) => `/companies/${companyId}/reporting/custom/reports/groups/structure` as const,
  copy: (companyId: string, reportId: number | string) =>
    `/companies/${companyId}/reporting/custom/reports/copy/${reportId}` as const,
  sectionList: (companyId: string, reportId: number) =>
    `/companies/${companyId}/reporting/custom/reports/${reportId}/sections` as const,
  section: (companyId: string, reportId: number, sectionId: number) =>
    `/companies/${companyId}/reporting/custom/reports/${reportId}/sections/${sectionId}` as const,
  explainer: (companyId: string, reportId: number | string, sectionId: number) =>
    `/companies/${companyId}/reporting/custom/reports/${reportId}/sections/${sectionId}/explain` as const,
  variable: (companyId: string, reportId: number, sectionId: number, variableId: number) =>
    `/companies/${companyId}/reporting/custom/reports/${reportId}/sections/${sectionId}/variables/${variableId}` as const,
  printExport: (contractId: number) => `/contracts/${contractId}/custom-report/print-export` as const
}

export default customReportEndpoints
